import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "Slices/Response/responseSlice";
import { setLoading, setTab, setShowRepitencia, setToast, setActiveAccordion, setShowBackdrop } from "Slices/uiSlice";
import {
    actaSatisfaccion, capacitacionesPendientes, editActa,
    generarActa, getClientesCapacitacion, getHistorialActa,
    getInvitadosCapacitacion, registroParticpante, registroPotencial, validaRepitencia
} from "Services/capacitacion_service";
import { sweetService } from "Services/sweet_service";
import { fetchNiveles, setNivelSeleccionado } from "Slices/NivelSatisfaccion/nivelSlice";
import { DataURIToBlob, getParamValue } from "Services/functions_service";
import { fileUri } from "Constantes/constants";
import { getCarteraSucursal } from "Services/byte_service";
import { getCursos } from "Services/cursos_service";
import { getDelegacionesUsuario } from "Services/delegacion_service";
import { fetchSucursalesAsignadas } from "Slices/Delegacion/delegacionSlice";
import { storageService } from "Services/storage_service";
import { setCarteraSucursal } from "Slices/Byte/byteSlice";
import { fetchCursos } from "Slices/Curso/cursoSlice";
import { Exception } from "sass";
import { fetchDistribucionItems } from "Slices/Distribucion/distribucionSlice";
import { getParametros } from "Services/param_service";
import { uploadFileS3 } from "Services/file_service";

const initialState = {
    clientesSeleccionados: [],
    invitados: [],
    selectedIds: [],
    carteraActiva: 0,
    disableCursos: false,
    disableCapacitacion: false,
    cursoSeleccionado: {
        idCurso: 0,
        titulo: '',
    },
    alertasRepitencia: [],
    fotografia: null,
    acta: 0,
    fechaCapacitacion: new Date(),
    capacitacionesPendientes: [],
    clientesCapacitacion: [],
    historialActa: [],
}

export const capacitacionSlice = createSlice({
    name: 'capacitacion',
    initialState,
    reducers: {
        setClientesSeleccionados: (state, action) => {
            state.clientesSeleccionados = action.payload;
        },
        setInvitadosCapa: (state, action) => {
            state.invitados = action.payload;
        },
        setSelectedIds: (state, action) => {
            state.selectedIds = action.payload;
        },
        setCarteraActiva: (state, action) => {
            state.carteraActiva = action.payload;
        },
        setDisableCursos: (state, action) => {
            state.disableCursos = action.payload;
        },
        setDisableCpacitacion: (state, action) => {
            state.disableCapacitacion = action.payload;
        },
        setCursoSeleccionado: (state, action) => {
            state.cursoSeleccionado = action.payload;
        },
        setAlertasRepitencia: (state, action) => {
            state.alertasRepitencia = action.payload;
        },
        setFotografia: (state, action) => {
            state.fotografia = action.payload;
        },
        setActa: (state, action) => {
            state.acta = action.payload;
        },
        setFechaCapacitacion: (state, action) => {
            state.fechaCapacitacion = action.payload;
        },
        setCapacitacionesPendientes: (state, action) => {
            state.capacitacionesPendientes = action.payload;
        },
        setClientesCapacitacion: (state, action) => {
            state.clientesCapacitacion = action.payload;
        },
        setHistorialActa: (state, action) => {
            state.historialActa = action.payload;
        },
        resetCapacitacion: () => initialState,
    }
});

export const fetchCapacitacionesPendientes = createAsyncThunk(
    'capacitacion/fetchPendientes',
    async (data, { dispatch }) => {
        dispatch(setShowBackdrop(true));
        if (data.idSucursal === -1) {
            const user = storageService.getItem('user');
            const delegacionRes = await getDelegacionesUsuario(user);
            if (delegacionRes?.length > 0) {
                await dispatch(fetchDistribucionItems({ ...user, codDistribucion: delegacionRes[0]?.codDistribucion, cartera: false }));
                if (delegacionRes[0]?.delegaciones.length === 1) {
                    const pendientesRes = await capacitacionesPendientes({ idSucursal: delegacionRes[0]?.delegaciones[0]?.idDistribucionByte });
                    dispatch(setCapacitacionesPendientes(pendientesRes));
                }
            }
        } else {
            const pendientesRes = await capacitacionesPendientes({ idSucursal: data.idSucursal });
            dispatch(setCapacitacionesPendientes(pendientesRes));
        }
        dispatch(setShowBackdrop(false));
    }
);

export const fetchDataCapacitacion = createAsyncThunk(
    'capacitacion/fetchData',
    async (data, { dispatch }) => {
        dispatch(setShowBackdrop(true));
        const user = storageService.getItem('user');
        await dispatch(fetchSucursalesAsignadas({ ...user, cartera: true }));
        await dispatch(fetchClientesCapacitacion(data));
        await dispatch(fetchInvitadosCapacitacion(data));
        await dispatch(fetchCursoCapa(data));
        await dispatch(fetchCursos({ codSegmento: 'capa' }));
        await dispatch(fetchNiveles());
        dispatch(setShowBackdrop(false));
    }
);

export const fetchClientesCapacitacion = createAsyncThunk(
    'capacitacion/fetchClientes',
    async (data, { dispatch }) => {
        const cliRes = await getClientesCapacitacion(data);
        const carteraRes = await getCarteraSucursal({ idSucursal: `${data.sucursal}` });
        const cliSel = cliRes ? carteraRes.filter(cartera => cliRes.find(cli => cartera.dpi === cli.dpi)) : null;
        const ids = cliRes.map(cli => carteraRes.findIndex(car => car.dpi === cli.dpi));
        await dispatch(setCarteraSucursal(carteraRes));
        await dispatch(setSelectedIds(ids));
        if (cliSel && cliSel?.length > 0) {
            await dispatch(setClientesSeleccionados(cliSel));
        }
    }
);

export const fetchInvitadosCapacitacion = createAsyncThunk(
    'capacitacion/fetchInvitados',
    async (data, { dispatch }) => {
        const invitadosRes = await getInvitadosCapacitacion(data);
        if (invitadosRes && invitadosRes?.length > 0) {
            dispatch(setInvitadosCapa(invitadosRes));
        }
    }
);

export const fetchCursoCapa = createAsyncThunk(
    'capacitaicon/curso',
    async (data, { dispatch }) => {
        const cursoRes = await getCursos({ idCategoria: null });
        if (cursoRes) {
            const cursoCapa = cursoRes.find(cur => cur.idCurso === data.idCurso);
            dispatch(setCursoSeleccionado(cursoCapa));
        }
    }
)

export const CargarNuevoGrupo = createAsyncThunk(
    'capacitacion/nuevoGrupo',
    async (data, { dispatch }) => {
        const user = storageService.getItem('user');
        dispatch(setShowBackdrop(true));
        await dispatch(fetchSucursalesAsignadas({ ...user, cartera: true }));
        await dispatch(fetchCursos({ codSegmento: 'capa' }));
        dispatch(setShowBackdrop(false));
    }
);

export const ValidaRepitencia = createAsyncThunk(
    'capacitacion/validaRepitencia',
    async (data, { dispatch }) => {
        const repitenciaRes = await validaRepitencia(data);
        if (repitenciaRes) {
            await dispatch(setAlertasRepitencia(repitenciaRes));
            dispatch(setShowRepitencia(true));
        }

    }
);

export const RegistrarGrupo = createAsyncThunk(
    'capacitacion/grupo',
    async (data, { dispatch }) => {
        dispatch(setLoading(true));
        const actaRes = await generarActa(data);
        dispatch(setResponse(actaRes));

        if (actaRes?.result) {
            const acta = actaRes.data;
            dispatch(setActa(acta));
            if (data.clientes && data.clientes.length > 0) {
                await Promise.all(
                    data.clientes.map((cli) => {
                        let cliente = {
                            idTipoCliente: 1,
                            idActa: acta,
                            fud: cli.codigo,
                            dpi: cli.dpi,
                            usuario: data.usuario,
                            prestamo: cli.credito
                        };

                        return registroParticpante(cliente);
                    })
                );
            }

            if (data.invitados && data.invitados.length > 0) {
                await Promise.all(
                    data.invitados.map(async (inv) => {
                        let invitado = {
                            idTipoCliente: 2,
                            idActa: acta,
                            nombre: inv.nombre,
                            apellido: inv.apellido,
                            fud: '',
                            dpi: inv.dpi,
                            usuario: data.usuario,
                        };

                        await registroPotencial(invitado);
                        return registroParticpante(invitado);
                    })
                );
            }

            let dataActa = {
                idActa: actaRes.data,
                idUsuario: data.idUsuario,
                idCurso: data.idCurso,
                idEstadoActa: 'conformada',
                usuario: data.usuario,
            }
            await editActa(dataActa);

            dispatch(setResponse({ result: 1, message: 'Se ha registrado el grupo' }));
            dispatch(setLoading(false));
            dispatch(resetCapacitacion());
            dispatch(setToast(true));
            setTimeout(() => {
                dispatch(setToast(false));
            }, 3000);
            dispatch(setTab(0));
        }
    }
);

export const ActaSatisfaccion = createAsyncThunk(
    'capacitacion/satisfaccion',
    async (data, { dispatch }) => {
        if (data.capa.idActa > 0) {
            let _actaSatisfaccion = {
                idNivel: data.nivel.idNivel,
                idCurso: data.capa.idCurso,
                idActa: data.capa.idActa,
                usuario: data.usuario.usuario
            }
            await actaSatisfaccion(_actaSatisfaccion);

            let dataActa = {
                idActa: data.capa.idActa,
                idUsuario: data.usuario.idUsuario,
                idCurso: data.capa.idCurso,
                idEstadoActa: 'encuesta',
                usuario: data.usuario.usuario,

            }
            await editActa(dataActa);
        }

        dispatch(setNivelSeleccionado(data.nivel));
        dispatch(setResponse({ result: 1, message: `Opción ${data.nivel.nombre} seleccionada` }));
        dispatch(setToast(true));
        setTimeout(() => {
            dispatch(setToast(false));
            dispatch(setActiveAccordion('fotografia'));
        }, 3000);

    }
);

export const GuardarCapa = createAsyncThunk(
    'capacitacion/finalizar',
    async (data, { dispatch }) => {
        dispatch(setLoading(true));
        if (data.clientes && data.clientes.length > 0) {
            const actaClientes = await Promise.all(
                data.clientes.map(async (cli) => {
                    let cliente = {
                        idTipoCliente: 1,
                        idActa: data.capa.idActa,
                        fud: cli.codigo,
                        dpi: cli.dpi,
                        usuario: data.usuario,
                        prestamo: cli.credito,
                    }
                    registroParticpante(cliente);
                })
            );
        }

        if (data.invitados && data.invitados.length > 0) {
            const actaClientes = await Promise.all(
                data.invitados.map(async (inv) => {
                    let invitado = {
                        idTipoCliente: 2,
                        idActa: data.capa.idActa,
                        nombre: inv.nombre,
                        apellido: inv.apellido,
                        fud: '',
                        dpi: inv.dpi,
                        usuario: data.usuario,
                    }
                    registroPotencial(invitado);
                    registroParticpante(invitado);
                })
            );
        }

        let dataActa = {
            idActa: data.capa.idActa,
            idUsuario: data.idUsuario,
            idCurso: data.capa.idCurso,
            idEstadoActa: 'confirmada',
            usuario: data.usuario,

        }
        await editActa(dataActa);

        sweetService.sweetAlert(
            data.capa.idActa > 0 ? 'Éxito' : 'Error',
            `Se generó el grupo: ${data.capa.idActa}`,
            data.capa.idActa > 0 ? "success" : "error");
        dispatch(setNivelSeleccionado({ idNivel: 0 }));

        try {
            if (data.fotografia) {
                const file = DataURIToBlob(data.fotografia);
                const formData = new FormData();
                formData.append('file', file, `${data.capa.idActa}.jpg`);
                formData.append('type', fileUri.actas);
                formData.append('tipo', fileUri.actas);
                formData.append('segmento', 1);
                await uploadFileS3(formData);
            } else {
                throw new Exception();
            }
        } catch (error) {
            let dataActa = {
                idActa: data.capa.idActa,
                idUsuario: data.idUsuario,
                idCurso: data.capa.idCurso,
                idEstadoActa: 'fotografiaPendiente',
                usuario: data.usuario,
            }
            await editActa(dataActa);
        }

        dispatch(resetCapacitacion());
        dispatch(setLoading(false));
        dispatch(setTab(0));
    }
);

export const GenerarActa = createAsyncThunk(
    'capacitacion/create',
    async (data, { dispatch }) => {
        dispatch(setLoading(true));
        const actaRes = await generarActa(data);
        dispatch(setResponse(actaRes));

        console.log(actaRes);

        if (actaRes?.result) {
            const acta = actaRes.data;
            dispatch(setActa(acta));
            if (data.clientes && data.clientes.length > 0) {
                const actaClientes = await Promise.all(
                    data.clientes.map((cli) => {
                        let cliente = {
                            idTipoCliente: 1,
                            idActa: acta,
                            fud: cli.codigo,
                            dpi: cli.dpi,
                            usuario: data.usuario,
                        }
                        registroParticpante(cliente);
                    })
                );
            }

            if (data.invitados && data.invitados.length > 0) {
                const actaInvitados = await Promise.all(
                    data.invitados.map((inv) => {
                        let invitado = {
                            idTipoCliente: 2,
                            idActa: acta,
                            nombre: inv.nombre,
                            apellido: inv.apellido,
                            fud: '',
                            dpi: inv.dpi,
                            usuario: data.usuario,
                        }
                        registroPotencial(invitado);
                        registroParticpante(invitado);
                    })
                );

            }

            let _actaSatisfaccion = {
                idNivel: data.idNivel,
                idCurso: data.idCurso,
                idActa: acta,
                usuario: data.usuario
            }

            await actaSatisfaccion(_actaSatisfaccion);

            sweetService.sweetAlert(
                acta > 0 ? 'Éxito' : 'Error',
                `${actaRes.message} ${actaRes.data}`,
                acta > 0 ? "success" : "error");
            dispatch(setNivelSeleccionado({ idNivel: 0 }));

            const file = DataURIToBlob(data.fotografia);
            const formData = new FormData();
            formData.append('file', file, `${acta}.jpg`);
            formData.append('type', fileUri.actas);
            formData.append('tipo', fileUri.actas);
            formData.append('segmento', 1);
            await uploadFileS3(formData);

            dispatch(resetCapacitacion());
            dispatch(setLoading(false));
            dispatch(setTab(0));
        }
    }
);

export const CancelarActa = createAsyncThunk(
    'capacitacion/cancelar',
    async (data, { dispatch }) => {
        let dataActa = {
            idActa: data.idActa,
            idUsuario: data.idUsuario,
            idCurso: data.idCurso,
            idEstadoActa: 'cancelada',
            usuario: data.usuario,
        }
        await editActa(dataActa);
        await dispatch(fetchCapacitacionesPendientes({ idSucursal: data.sucursal }));
        dispatch(setResponse({ result: 1, message: `Capacitación cancelada` }));
        dispatch(setToast(true));
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);

    }
);

export const fetchHistorialActa = createAsyncThunk(
    'capacitacion/fetchHistorial',
    async (data, { dispatch }) => {
        console.log('obteniendo historial');
        const altUrlSoporte = await getParametros({ codigo: 'soporte' });
        const urlSoporte = getParamValue(altUrlSoporte, 'soporte', 'codigoParametro', 'parametro');
        const historialRes = await getHistorialActa(data);
        dispatch(setHistorialActa(historialRes));
        if (historialRes && historialRes.length > 0 && historialRes[0]?.idCaso) {
            dispatch(setFotografia(`${urlSoporte}${historialRes[0].idCaso}-cli.jpg`));
        }
    }
);

export const { setClientesSeleccionados, setInvitadosCapa, setSelectedIds,
    setCarteraActiva, setShowCursos, setDisableCpacitacion,
    setDisableCursos, setCursoSeleccionado, setAlertasRepitencia,
    setFotografia, resetCapacitacion, setActa, setFechaCapacitacion,
    setCapacitacionesPendientes, setClientesCapacitacion, setHistorialActa } = capacitacionSlice.actions;

export default capacitacionSlice.reducer;